import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { isEmpty, getValidationError } from '../FormElement/FormElementUtils';
import CheckBox from '../CheckBox/CheckBox';
const LOCALE_PREFIX = 'components/PPTermsCheckBox/PPTermsCheckBox';

export class TermsCheckBox extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        termsCheckboxLabel: PropTypes.element.isRequired
    };

    render() {
        const { intl, termsCheckboxLabel } = this.props;

        return (
            <div className="vx_col-md-12">
                <Field
                    id="terms"
                    name="terms"
                    label={termsCheckboxLabel}
                    component={CheckBox}
                    allowErrorPopout={true}
                    validate={isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.terms-not-accepted`}))}
                    alignLabelTop={true}
                />
            </div>
        );
    }
}
export default injectIntl(TermsCheckBox);
